import { getLenis } from './smoothscroll';

const HEADER_HEIGHT_VAR = '--header-height';

function getHeaderOffset() {
  const value = getComputedStyle(document.documentElement).getPropertyValue(HEADER_HEIGHT_VAR);

  return parseInt(value, 10) || 0;
}

function scrollToHash(hash) {
  const target = document.getElementById(hash);

  if (!target) return false;

  const offset = -getHeaderOffset();
  const lenis = getLenis();

  if (lenis) {
    lenis.scrollTo(target, { offset });
  } else {
    const top = target.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  history.replaceState(null, '', window.location.pathname + window.location.search);

  return true;
}

function onClick(e) {
  const link = e.target.closest('a[href*="#"]');

  if (!link) return;

  const url = new URL(link.href, window.location.href);

  if (url.pathname !== window.location.pathname || !url.hash) return;

  if (scrollToHash(url.hash.slice(1))) {
    e.preventDefault();
  }
}

export default function setAnchors() {
  document.addEventListener('click', onClick);

  if (window.location.hash) {
    scrollToHash(window.location.hash.slice(1));
  }
}
